import { createStore } from 'vuex';
import main from './modules/main-module';
import agents from './modules/agents-module';
import session from './modules/session-module';
import dashboard from './modules/dashboard-module';
import settings from './modules/settings-module';
import { modulesPreProccess } from './service';

const store = createStore({
  modules: modulesPreProccess({
    main,
    agents,
    session,
    settings,
    dashboard,
  }),
});
export default store;

// Vue.use(Vuex);

// export default new Vuex.Store({
//  modules: modulesPreProccess({
//   main,
//   agents,
//   session,
//   settings,
//   dashboard,
//  }),
// });
